import React, { useState, useEffect } from 'react';
import UserForm from './UserForm';
import { Link } from 'react-router-dom';
import useDeleteUser from '../../../hooks/useDeleteUser';
import './usersView.css'

const UsersView = () => {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [error, setError] = useState('');
  const [flashMessage, setFlashMessage] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  
  const { deleteUser, loading: deleteLoading } = useDeleteUser();

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (flashMessage) {
      const timer = setTimeout(() => {
        setFlashMessage(null); // Clear the flash message after 3 seconds
      }, 3000);
      
      // Cleanup the timer on component unmount or when flashMessage changes
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/admin/users`, {
        method: 'GET',
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        const usersData = data.data || data; 
        setUsers(usersData);
      } else {
        setError('Failed to fetch users.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    }
  };

  const handleAddClick = () => {
    setShowForm(true);
  };

  const handleGoBackClick = () => {
    setShowForm(false)
  }

  const handleFormSubmit = (isUpdate) => {
    setIsUpdate(isUpdate);
    setShowForm(false);
    fetchUsers();
    setFlashMessage(isUpdate ? 'Usuario Actualizado' : '¡Usuario creado exitosamente! Se ha enviado una contraseña temporal por email.');
  };

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!userToDelete) return;

    try {
      await deleteUser(userToDelete.id);
      setFlashMessage('Usuario eliminado exitosamente');
      fetchUsers(); // Refresh the users list
      setShowDeleteConfirm(false);
      setUserToDelete(null);
    } catch (error) {
      setFlashMessage(`Error al eliminar usuario: ${error.message}`);
      setShowDeleteConfirm(false);
      setUserToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setUserToDelete(null);
  };

  return (
    <div className="users-view__container">
      {flashMessage && (
        <div className={`flash-message ${flashMessage.type}`}>
          <p id="flash-message-text">{flashMessage}</p>
        </div>
      )}

      <div className="users-view__title-create-container">
        <h1>Usuarios</h1>
        <button className="users-view__button" onClick={showForm ? handleGoBackClick : handleAddClick}>
          {showForm ? '<- volver' : '+ agregar'} 
        </button>
      </div>

      {showForm ? (
        <UserForm isEditing={false} onFormSubmit={() => handleFormSubmit(false)}  onGoBack={handleGoBackClick} setFlashMessage={setFlashMessage} />
      ) : (
        <div className="users-view__table-container">
          <table className="users-view__full-width-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th className="email-column">Email</th>
                <th>Rol</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map(user => (
                  <tr key={user.id} className="body-row">
                    <td>{user.name || 'juanete'}</td>
                    <td>{user.phoneNumber || '+56976212646'}</td>
                    <td className="email-column">{user.email}</td>
                    <td>{user.role}</td>
                    <td className="users-view__actions">
                      <Link to={`/panel-empresa/usuarios/${user.id}`}>
                        <button className="users-view__table-edit-button">editar</button>
                      </Link>
                      {/* Allow deleting all users except the current user */}
                      <button 
                        className="users-view__table-delete-button"
                        onClick={() => handleDeleteClick(user)}
                        disabled={deleteLoading}
                      >
                        {deleteLoading ? 'eliminando...' : 'eliminar'}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No se han creado usuarios</td>
                </tr>
              )}
            </tbody>
          </table>
          {/* {error && <p className="error">{error}</p>} */}
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      {showDeleteConfirm && (
        <div className="users-view__delete-overlay">
          <div className="users-view__delete-modal">
            <h3>Confirmar eliminación</h3>
            <p>¿Estás seguro de que quieres eliminar al usuario <strong>{userToDelete?.name}</strong> ({userToDelete?.email})?</p>
            <p>Esta acción no se puede deshacer.</p>
            <div className="users-view__delete-actions">
              <button 
                className="users-view__delete-cancel-button"
                onClick={handleDeleteCancel}
                disabled={deleteLoading}
              >
                Cancelar
              </button>
              <button 
                className="users-view__delete-confirm-button"
                onClick={handleDeleteConfirm}
                disabled={deleteLoading}
              >
                {deleteLoading ? 'Eliminando...' : 'Eliminar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersView;
